<template>
  <div class="right-hand-rule-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>B = μ₀I / (2πr) | 右手定则一$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <defs>
             <marker id="arrow-blue" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
                <path d="M0,0 L6,3 L0,6 Z" fill="#00d2ff" />
             </marker>
          </defs>

          <!-- Current-carrying wire -->
          <line x1="200" y1="240" x2="200" y2="20" stroke="#747d8c" stroke-width="8" stroke-linecap="round" />
          
          <!-- Current direction arrow -->
          <line x1="200" y1="180" x2="200" y2="100" stroke="#ff4757" stroke-width="3" marker-end="url(#torque-arrow)" />
          <text x="215" y="110" fill="#ff4757" font-weight="bold">I (电流)</text>

          <!-- Magnetic Field Lines (Circles around wire) -->
          <g v-for="r in [40, 70, 100]" :key="r">
             <ellipse cx="200" cy="120" :rx="r" :ry="r/3" 
                      fill="none" stroke="rgba(0, 210, 255, 0.4)" stroke-width="1.5" stroke-dasharray="5,3" />
             <!-- Direction arrows on field lines -->
             <path :d="getArrowPath(r)" fill="none" stroke="#00d2ff" stroke-width="2" marker-end="url(#arrow-blue)" />
          </g>

          <!-- The Hand Hint (Optional or abstract) -->
          <g transform="translate(180, 130) scale(0.6)" opacity="0.3">
             <!-- Abstract hand shape -->
             <path d="M 0,0 C 0,0 20,-40 40,-40 C 60,-40 70,0 70,0" fill="none" stroke="#fff" stroke-width="2" />
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>右手握线: 大拇指指电流方向，四指弯曲指磁感线方向</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center justify-center gap-4">
            <el-radio-group v-model="direction" size="mini">
              <el-radio-button label="up">电流向上 (↑)</el-radio-button>
              <el-radio-button label="down">电流向下 (↓)</el-radio-button>
            </el-radio-group>
            <div class="flex-1">
               <label>电流强度 I</label>
               <el-slider v-model="intensity" :min="1" :max="10" size="mini"></el-slider>
            </div>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>安培定则（右手螺旋定则）是表示电流和电流激发磁场的磁感线方向间关系的定则。
           对于直线电流：右手握住导线，大拇指指向**电流方向**，弯曲的四指则指向**磁感线方向**。如果是通电螺线管，则四指弯曲方向为电流方向，大拇指指出的则是其**内部**磁场（北极）方向。这种手性关系反映了磁场作为一个矢量场的数学本性，也是建立电磁学直觉的基础。</p>
        </div>
      </div>
    </div>
    
    <svg height="0" width="0">
      <defs>
        <marker id="torque-arrow" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
           <path d="M0,0 L6,3 L0,6 Z" fill="#ff4757" />
        </marker>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'RightHandRuleViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      direction: 'up',
      intensity: 5,
      t: 0,
      timer: null
    }
  },
  methods: {
    getArrowPath(r) {
       // Create an arc for the arrow direction based on 'direction'
       const cy = 120;
       const x = 200 + r;  // eslint-disable-line no-unused-vars
       if (this.direction === 'up') {
          // Counter-clockwise from top-view, but in 3D perspective...
          // For 'up' current, front side (y > cy) goes left -> right?
          // Right hand rule: Up -> CCW top view. Front curve goes right.
          return `M ${200-r},${cy} A ${r},${r/3} 0 0 0 ${200+r},${cy}`;
       } else {
          return `M ${200+r},${cy} A ${r},${r/3} 0 0 0 ${200-r},${cy}`;
       }
    }
  }
}
</script>

<style scoped lang="scss">
.right-hand-rule-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
